import * as React from "react"
import { wrap, increment, decrement, input } from "./numeric-input.module.css"
import { useSeekaConverge } from '@seeka-labs/converge-react';


export function NumericInput({
  onIncrement,
  onDecrement,
  className,
  disabled,
  variantId, quantity, available, product, title, vendor, metafield,
  ...props
}) {

  const converge = useSeekaConverge();
   // Fetching the variant SKU similar to the first code snippet
  const { sku, unitPrice, categoryName } = props;
  
  const handleIncrement = () => {
    onIncrement(); 
    converge.track.addToCart({
      currencyCode: 'SGD', 
      productIdentifier: product.id, 
      variantIdentifier: variantId, 
      sku: sku,
      productName: title, 
      categoryName: categoryName,
      brandName: vendor, 
      unitPrice: unitPrice,
      quantity: 1, 
      totalInventory: product.totalInventory || 0,
      totalDiscount: 0, 
      lineItemIdentifier: '', // You might need to replace this with an actual line item identifier if available
    }).catch(error => {
      console.error('Error adding to cart:', error);
    });
  };

  const handleDecrement = () => {
    onDecrement(); 
    converge.track.removeFromCart({
      currencyCode: 'SGD', 
      productIdentifier: product.id, 
      variantIdentifier: variantId, 
      sku: sku,
      productName: title, 
      categoryName: categoryName,
      brandName: vendor, 
      unitPrice: unitPrice,
      quantity: 1, 
      totalInventory: product.totalInventory || 0,
      totalDiscount: 0, 
      lineItemIdentifier: '', // You might need to replace this with an actual line item identifier if available
    }).catch(error => {
      console.error('Error removing from cart:', error);
    });
  };


  return (
    <div className={wrap}>
      <button
        disabled={disabled}
        className={decrement}
        aria-label="Decrement"
        onClick={handleDecrement}
      >
        <p>-</p>
      </button>
      <input
        disabled={disabled}
        type="numeric"
        readOnly
        className={[input, className].join(" ")}
        {...props}
      />
       <button
        disabled={disabled}
        className={increment}
        aria-label="Increment"
        onClick={handleIncrement}
      >
        <p>+</p>
      </button>
     
    </div>
  )
}
